import React from 'react';
import CardButton from './CardButton';
import StatsWrapper from '../../utils/StatsWrapper';

const NewAmazonCard = ({ amazonLocation, referralLink, image, orderCount = 0 }) => {
  const handleSupportClick = () => {
    StatsWrapper.track('item.new_amazon_support_clicked', { amazonLocation });
    window.open(referralLink, '_blank');
  };

  return (
    <div className="border rounded-lg shadow-md p-4 bg-white">
      <div className="flex flex-col h-full">
        <div className="flex justify-center items-center h-48 mb-4 bg-gray-50 rounded-md">
          <img src={image} alt="Amazon" className="w-full h-full object-cover rounded-md border border-gray-200" />
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
          עזרו לנו להרחיב את השירות לאמזון {amazonLocation.toUpperCase()}!
        </h3>
        
        <p className="text-gray-600 mb-4 text-center">
          כדי שנוכל לחפש ולעקוב אחרי מוצרים באמזון חדש, חייבים שיהיו לנו לפחות<b> 3 הזמנות מאותו אמזון ב180 הימים האחרונים</b>, אז אם יש משהו שרציתם להזמין מ{amazonLocation.toUpperCase()}, תשתמשו בכפתור כאן ותעזרו לכולם להינות! הוזמנו {orderCount} עד כה!
        </p>
        
        <div className="flex-grow" />
        
        <div className="flex justify-center mt-4">
          <CardButton
            text={
                <span>לקניה באמזון  {amazonLocation.toUpperCase()}</span>
            }
            onClick={handleSupportClick}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default NewAmazonCard; 